import { PropTypes } from 'prop-types';
import React, { useState } from 'react';

import { COLORS } from '../../../constants/colors';
import Link from '../../Link';
import TitleLabel from '../../Titles/TitleLabel';
import CardImageBasedXLargeControls from './CardImageBasedXLargeControls';
import CardImageBasedXLargeSwiper from './CardImageBasedXLargeSwiper';

const DEFAULT_THEME = {
  backgroundColor: COLORS.squidInk,
  color: COLORS.ocean,
};

const CardImageBasedXLargeFullWidth = ({ carousel, theme = DEFAULT_THEME }) => {
  // store swiper instance
  const [swiper, setSwiper] = useState(null);
  const [realIndex, setRealIndex] = useState(null);

  const slide = carousel?.[realIndex];
  const title = slide?.title;
  const tags = slide?.tags;

  return (
    <div className="relative flex flex-col sm:flex-row-reverse ">
      {/* swiper */}
      <div className="relative sm:w-1/2">
        <div className="absolute bottom-0 right-0 z-10 sm:left-0 sm:right-auto">
          <CardImageBasedXLargeControls
            carousel={carousel}
            orderClassName="sm:flex-row-reverse"
            realIndex={realIndex}
            swiper={swiper}
            theme={theme}
          />
        </div>

        <CardImageBasedXLargeSwiper
          carousel={carousel}
          className="h-64 sm:h-[420px] lg:h-[466px] image-hover"
          setRealIndex={setRealIndex}
          setSwiper={setSwiper}
        />
      </div>
      {/* title, description */}
      <div
        className=" sm:absolute sm:inset-0 bg-[color:var(--swiper-content-background-color)] "
        style={{
          '--swiper-content-background-color': theme.backgroundColor,
          '--swiper-content-color': theme.color,
        }}
      >
        <div className="h-full homepage-grid-container">
          <div className="text-[color:var(--swiper-content-color)] col-span-12 sm:col-span-5 lg:col-span-9 sm:h-auto flex flex-col justify-between h-40 py-4.5 sm:pt-8 sm:pb-12 overflow-hidden">
            <TitleLabel
              color="text-[color:var(--swiper-content-color)]"
              tags={tags}
            />
            <h3 key={realIndex?.toString()} className="translate-up stink-h3">
              <Link className="stink-h3 text-hover" to={slide?.url}>
                {title}
              </Link>
            </h3>
          </div>
        </div>
      </div>
    </div>
  );
};

CardImageBasedXLargeFullWidth.propTypes = {
  carousel: PropTypes.array,
  theme: PropTypes.object,
};

export default CardImageBasedXLargeFullWidth;
